import { Whoops } from '@hungryroot/icons';
import { Button, Heading, Paragraph } from '@hungryroot/ramen';

import styles from './UnknownAppCrash.module.css';

export function UnknownAppCrash() {
  return (
    <div className={styles.container}>
      <Whoops className={styles.illustration} />
      <div className={styles['text-content']}>
        <Heading variant="H2" className={styles.title}>
          Whoops!
        </Heading>
        <Paragraph className={styles.body} variant="body">
          Clean up on aisle...well, all of the aisles. Hang tight—we'll look
          into this issue but in the meantime, you can try refreshing the page
          or head back to our homepage.
        </Paragraph>
      </div>
      <Button
        prominence="primary"
        size="medium"
        style="muted"
        buttonType="link"
        to="/"
        textPrimary="Back to home"
      />
    </div>
  );
}
